export const keys = {
	boards: ["myViewV2", "boards"],
	catalog: ["myViewV2", "catalog"],
	widgets: (id: number) => ["myViewV2", "widgets", id],
};
